import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import { resolveAsset, optimizeImage, getImageDimensions, colorStyle, srcSet } from '@/lib/helpers';
import StoryblokRichText from '@/components/StoryblokRichText';

const ContentImage = ({ blok }) => {
  const imageLeft = blok.image_position === 'left';
  const imageSrc = resolveAsset(blok.image);
  const imageDims = getImageDimensions(imageSrc);
  const imageSize = blok.image_size || '';   // e.g. 'max-w-[300px]', or '' for default 50/50
  const isFixed = !!imageSize;
  // Fixed column caps at its px width; otherwise full-width on mobile, ~half from md.
  const cap = imageSize.match(/\[(\d+)px\]/);
  const sizes = cap ? `(max-width: ${cap[1]}px) 100vw, ${cap[1]}px` : '(max-width: 1024px) 100vw, 50vw';

  return (
    <section {...storyblokEditable(blok)} className="px-4 py-8 sm:p-12 lg:p-16" style={colorStyle(blok)}>
      <div className="max-w-container mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
          <div
            className={`${isFixed ? `${imageSize} shrink-0 mx-auto md:mx-0` : 'flex-1 w-full'} ${imageLeft ? 'md:order-first' : 'md:order-last'} order-first`}
          >
            {imageSrc && (
              <img
                src={optimizeImage(imageSrc, isFixed ? 600 : 700, 0)}
                srcSet={srcSet(imageSrc)}
                sizes={sizes}
                alt={blok.image?.alt || ''}
                width={imageDims?.width || 700}
                height={imageDims?.height || 500}
                className="w-full h-auto rounded-lg"
                loading="lazy"
              />
            )}
          </div>

          <div className="flex-1 flex flex-col gap-4">
            {blok.text && (
              <StoryblokRichText
                content={blok.text}
                className="text-16 sm:text-18"
                invert={blok.text_color === '#FFFFFF'}
              />
            )}
            {blok.body?.map((b) => <StoryblokServerComponent blok={b} key={b._uid} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentImage;
